import { api } from "./api.ts";
import type { PaginatedResponse } from "types/DataTypes";

export type ClientInstructionType = {
  id: number;
  client: number;
  instructions: string;
  created: string;
  modified: string;
};

type CreateInstructionArgs = {
  data: Partial<ClientInstructionType>;
};

type PatchInstructionArgs = {
  id: number | string;
  data: Partial<ClientInstructionType>;
};

type GetInstructionsArgs = {
  clientId: number;
  limit?: number;
  offset?: number;
};

type DeleteInstructionArgs = {
  id: number | string;
};

export const clientInstructionApi = api.injectEndpoints({
  endpoints: (build) => ({
    createInstruction: build.mutation<
      ClientInstructionType,
      CreateInstructionArgs
    >({
      query: ({ data }) => ({
        url: `api/v1/client-instructions/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ClientInstructions"],
    }),
    patchInstructionById: build.mutation<
      ClientInstructionType,
      PatchInstructionArgs
    >({
      query: ({ id, data }) => ({
        url: `api/v1/client-instructions/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["ClientInstructions"],
    }),
    getInstructions: build.query<
      PaginatedResponse<ClientInstructionType>,
      GetInstructionsArgs
    >({
      query: ({ clientId, limit, offset }) => ({
        url: `api/v1/client-instructions/`,
        method: "GET",
        params: {
          client: clientId,
          limit,
          offset,
        },
      }),
      providesTags: ["ClientInstructions"],
    }),
    deleteInstruction: build.mutation<void, DeleteInstructionArgs>({
      query: ({ id }) => ({
        url: `api/v1/client-instructions/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ClientInstructions"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateInstructionMutation,
  usePatchInstructionByIdMutation,
  useGetInstructionsQuery,
  useDeleteInstructionMutation,
} = clientInstructionApi;
